/* One presentation rule for EUR amounts, including cart/search/app updates.
   Numeric values, structured data and input values are never changed. */
(()=>{
  const skip='script,style,textarea,input,select,option,svg,[contenteditable=true]';
  const euro=/€[\s\u00a0]*(\d+(?:[.,]\d+)*)/g;
  function text(node){
    if(!node.nodeValue.includes('€')||node.parentElement?.closest(skip))return;
    const next=node.nodeValue.replace(euro,'$1\u00a0€');
    if(next!==node.nodeValue)node.nodeValue=next;
  }
  function walk(root){
    if(root.nodeType===3){text(root);return;}
    if(root.nodeType!==1||root.matches(skip))return;
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    while(walker.nextNode())text(walker.currentNode);
    // Some cart renderers put currency and amount in separate spans.
    root.querySelectorAll('.price-currency').forEach(currency=>{
      if(currency.textContent.trim()!=='€')return;
      const amount=currency.nextElementSibling;
      if(amount?.classList.contains('price-amount')){amount.after(currency);currency.textContent='\u00a0€';}
    });
  }
  walk(document.body);
  new MutationObserver(records=>{
    for(const r of records){
      if(r.type==='characterData')text(r.target);
      else r.addedNodes.forEach(walk);
    }
  }).observe(document.body,{subtree:true,childList:true,characterData:true});
})();
